/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_ReloadInputs */

const vi_common_error_reload = /** @type {(inputs: Common_Error_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xảy ra lỗi. Vui lòng tải lại trang.`)
};

/**

* @param {Common_Error_ReloadInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_error_reload = /** @type {((inputs?: Common_Error_ReloadInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_ReloadInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_error_reload(inputs)
});